var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notData"},[(_vm.className)?_c('i',{class:_vm.className}):_vm._e(),_c('p',[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }